// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.BiText = function BiText (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M5 8L7 8 7 6 10.252 6 7.68 18 5 18 5 20 13 20 13 18 10.748 18 13.32 6 17 6 17 8 19 8 19 4 5 4z"}}]})(props);
};
